import { FacilityListService } from './../core/service/grid-data/grid-data-facility.service';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { FacilityListComponent } from './facility-list/facility-list.component';
import { FacilityEditComponent } from './facility-edit/facility-edit.component';
import { AddressValidatorModule } from '../shared/address-validator/address-validator.module';

@NgModule({
  declarations: [FacilityListComponent, FacilityEditComponent],
  imports: [
    SharedModule,
    AddressValidatorModule
  ],
  providers: [FacilityListService]
})
export class FacilityModule { }
